import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from 'react-router-dom';
import classes from "./RegisterUser.module.css";
import UserService from "../../Services/UserService";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import MessagePopup from "../PopupComponent/MessagePopup";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

/**
 * Renders add user pop up to register user
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function AddUser(props) {

    //#region States

    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    const [roles, setRoles] = useState([]);

    //#endregion

    //#region Refs

    const usernameInputRef = useRef();
    const roleInputRef = useRef();
    const emailInputRef = useRef();
    const passwordInputRef = useRef();
    //#endregion

    //#region useEffect hook

    /**
    * Calls user service to fetch roles
    * Runs only on the first render
    */
    useEffect(() => {
        UserService.getAllRoles().then((getRolesResponse) => {
            if (getRolesResponse.response == null) {
                setError(getRolesResponse.errors[0].message)
            }
            else {
                setRoles(getRolesResponse.response)
            }
        }).catch((err) => {
            setError(err.data);
        });
    }, [])

    //#endregion

    //#region Add User

    /**
    * Calls user service to register user
    * @param   {Event} event  User action (on submitting form)
    */
    function createHandler(event) {
        event.preventDefault();

        const enteredUsername = usernameInputRef.current.value;
        const enteredRole = roleInputRef.current.value;
        const enteredEmail = emailInputRef.current.value;
        const enterdPassword = passwordInputRef.current.value;

        var registeruserDTO = {
            Request: {
                Username: enteredUsername,
                Role: enteredRole,
                Email: enteredEmail,
                Password: enterdPassword,
            }
        };

        UserService.registerUser(registeruserDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage(response.response.message);
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Add User</strong>
                </ModalTitle>
            </ModalHeader>

            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={createHandler}>
                    <div style={{ padding: '3%' }}>
                        <div >
                            <label for="Username" className="label">Username</label>
                            {/* autoComplete off/new-password: this is an admin creating someone
                                else's account, so the browser must not autofill it with the
                                signed-in admin's own saved credentials. */}
                            <input
                                className="InputField"
                                type="text"
                                placeholder="-Text-"
                                min="0"
                                maxlength="30"
                                ref={usernameInputRef}
                                autoComplete="off"
                                required
                            />
                        </div>
                        <br />
                        <div>
                            <label for="Role" className="label">Role</label>
                            <div>
                                <select className="InputField" id="role" aria-label="Default select example" ref={roleInputRef} required >
                                    <option value="" selected >-Select-</option>
                                    {roles?.map((role) => (
                                        <option value={role}>{role}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <br />
                        <div >
                            <label for="Email" className="label">Email</label>
                            <input className="InputField"
                                type="email"
                                placeholder="-Text-"
                                ref={emailInputRef}
                                required
                            />
                        </div>
                        <br />
                        <div className="mb-3">
                            <label for="Password" className="label">Password</label>
                            <input
                                className="InputField"
                                type="password"
                                placeholder="-Text-"
                                ref={passwordInputRef}
                                autoComplete="new-password"
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                            <div>
                                <button type="reset" className="secondary-button">
                                    <span className="secondary-button-icon"><ResetIcon /></span>
                                    <span className="secondary-button-text">Reset</span>
                                </button>
                                &nbsp;
                                <button type="submit" className="primary-button ">
                                    <span className="primary-button-icon"><AddIcon /></span>
                                    <span className="primary-button-text">Add User</span>
                                </button>

                            </div>
                        </ModalFooter>
                    </div>
                </form>
            </Modal.Body>
        </Modal >
    );
}

export default AddUser;